// src/app/api/auth.interceptor.fn.ts
import { HttpInterceptorFn, HttpHeaders } from '@angular/common/http';
import { inject } from '@angular/core';
import { BaseAuthenticatedService } from '@app/services/base-authenticated.service';
import { ApiAuthenticatedService } from './api.module';
import { ADD_BACKEND_AUTH, SKIP_BACKEND_AUTH } from './auth.tokens';
import { switchMap } from 'rxjs';
import { environment } from '@environments/environment';

export const authInterceptorFn: HttpInterceptorFn = (req, next) => {
  if (req.context.get(SKIP_BACKEND_AUTH)) {
    return next(req); // explicit opt-out for anonymous public calls
  }
  // ADD_BACKEND_AUTH;
  console.debug(
    'AuthInterceptorFn',
    req.method,
    req.url,
    req.context.get(ADD_BACKEND_AUTH)
  );
  const targetsBackend = req.url.startsWith(environment.backendDomain);
  if (!req.context.get(ADD_BACKEND_AUTH) && !targetsBackend) {
    return next(req); // bypass totale
  }

  const authSvc = inject(ApiAuthenticatedService);

  // Se serve, aggiungi log:
  // console.info('[AuthInterceptorFn]', req.method, req.url);

  const wantsMultipart =
    req.body instanceof FormData ||
    req.headers.get('Content-Type') === 'multipart/form-data';

  const baseHeaders: Record<string, string> = {};
  baseHeaders['Content-Type'] = wantsMultipart
    ? 'multipart/form-data'
    : req.headers.get('Content-Type') ?? 'application/json';

  return authSvc.getAuthHeaders(baseHeaders).pipe(
    // usa lo stesso switchMap del tuo esempio classico
    // ma qui bastano poche righe:
    // (se getAuthHeaders ti restituisce HttpHeaders già con Authorization)
    switchMap((headers) => {
      let cloned = req.clone({ headers });
      return next(cloned);
    })
    // (source) => {
    //   return source.pipe((obs) => {
    //     let cloned = req.clone({ headers: obs as any });
    //     return next(cloned);
    //   });
    // }
  );
};
